export default function PrivacyText() {
  return (
    <div className=" mt-2 mb-4 text-xs text-left font-medium color222">
      <p className="">
        We’ll call or text you to confirm your number. Standard message and data
        rates apply.
      </p>
      <a href='https://www.airbnb.com/help/article/2855' target="_blank" className="underline font-bold">Privacy Policy</a>
    </div>
  );

}
